export const APP_ROUTES = {
    VALIDATING: '/',
    RESET_PASSWORD: '/reset-password',
    SIGN_IN: '/sign-in',
    INVALID_SESSION: '/invalid-session',
    NUMBER_STATUS: '/number-status',
    NUMBER_STATUS_HELP: '/number-status-help',
    CONSENT_RELATIONSHIP: '/consent-relationship',
};
